import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { coreApi } from '../../../../utils/axios';

export type AlphegaMembership = {
  pharmacy_id: string;
  membership_id: string | null;
  alphega_account_number: string | null;
};

export type UpdateAlphegaMembershipPayload = {
  is_member: boolean;
  alphega_account_number: string | null;
};

type GetAlphegaMembershipResponse = {
  data: AlphegaMembership;
};

const ALPHEGA_QUERY_KEY = 'alphega-membership';

const getAlphegaMembership = (pharmacyId: string) => {
  return coreApi.get<GetAlphegaMembershipResponse>(`/pharmacies/${pharmacyId}/alphega-membership`);
};

const updateAlphegaMembership = (pharmacyId: string, payload: UpdateAlphegaMembershipPayload) => {
  return coreApi.put<GetAlphegaMembershipResponse>(`/pharmacies/${pharmacyId}/alphega-membership`, payload);
};

export function useAlphegaMembership(pharmacyId: string) {
  return useQuery({
    queryKey: [ALPHEGA_QUERY_KEY, pharmacyId],
    queryFn: async () => {
      const response = await getAlphegaMembership(pharmacyId);
      return response.data.data;
    },
    enabled: !!pharmacyId,
    refetchOnWindowFocus: false,
  });
}

export function useUpdateAlphegaMembership(pharmacyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateAlphegaMembershipPayload) => {
      const response = await updateAlphegaMembership(pharmacyId, payload);
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ALPHEGA_QUERY_KEY, pharmacyId] });
    },
  });
}
